// Critical images that should be preloaded
export const CRITICAL_IMAGES = [
  '/src/assets/images/photo.png',
  '/src/assets/images/Title.png',
  '/src/assets/images/background.jpg'
];

// Preload critical images
export const preloadCriticalImages = () => {
  CRITICAL_IMAGES.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};

// Generate responsive image sizes
export const getResponsiveImageSizes = (baseSrc, sizes = []) => {
  if (!sizes.length) {
    return baseSrc;
  }
  
  // For now, return the base src
  // In a production environment, you'd generate different sized images
  return baseSrc;
};

// Image optimization settings
export const IMAGE_OPTIONS = {
  quality: 85,
  format: 'webp',
  lazy: true,
  placeholder: true
};

// Convert image to WebP format (placeholder for actual implementation)
export const convertToWebP = (src) => {
  // In a real implementation, you'd use a service like Cloudinary or similar
  // For now, return the original src
  return src;
};

// Generate low-quality placeholder
export const generatePlaceholder = (src) => {
  // In a real implementation, you'd generate a tiny version of the image
  // For now, return a data URL of a tiny colored square
  return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjZjNmNGY2Ii8+Cjwvc3ZnPgo=';
};
